import { InputField } from 'components/InputField';
import { LabelField } from "components/LabelField";
import React from 'react';
import { Col, Row } from 'react-bootstrap';

const TranzilaForm = ({formik, disabled}) => {
  return (
    <>
      <Row>
        <Col className="col-sm-6">
          <LabelField title="Terminal Name" mandatory hint="Your Tranzila terminal name, found in your Tranzila merchant dashboard. Required together with the App Key and Secret Key." />
          <InputField
            type="password"
            mandatory={true}
            {...{
              formik,
              title: 'none',
              formStyle: { marginBottom: 0 },
              name: 'terminal_name',
              placeholder: 'Terminal Name',
              checkValidation: true,
            }}
            value={disabled ? "...................." : formik.values?.tranzila?.terminal_name}
            handleChange={(e) => {
              formik.setFieldValue('tranzila.terminal_name', e.target?.value);
            }}
            autoComplete="new-password"
          />
        </Col>
        <Col className="col-sm-6">
          <LabelField title="App Key" mandatory hint="Your Tranzila app key, found in your Tranzila merchant dashboard alongside the Terminal Name and Secret Key." />
          <InputField
            type="password"
            mandatory={true}
            {...{
              formik,
              title: 'none',
              formStyle: { marginBottom: 0 },
              name: 'app_key',
              placeholder: 'App Key',
              checkValidation: true,
            }}
            value={disabled ? "...................." : formik.values?.tranzila?.app_key}
            handleChange={(e) => {
              formik.setFieldValue('tranzila.app_key', e.target?.value);
            }}
            autoComplete="new-password"
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-sm-6">
          <LabelField title="Secret Key" mandatory hint="Your Tranzila secret key, found in your Tranzila merchant dashboard alongside the Terminal Name and App Key." />
          <InputField
            type="password"
            mandatory={true}
            {...{
              formik,
              title: 'none',
              formStyle: { marginBottom: 0 },
              name: 'secret_key',
              placeholder: 'Secret Key',
              checkValidation: true,
            }}
            value={disabled ? "...................." : formik.values?.tranzila?.secret_key}
            handleChange={(e) => {
              formik.setFieldValue('tranzila.secret_key', e.target?.value);
            }}
            autoComplete="new-password"
          />
        </Col>
      </Row>
    </>
  )
}

export default TranzilaForm
